import React from "react"
import { motion } from "framer-motion"

export const Services: React.FC = () => {
	return (
		<section id='services' className='py-16 px-6 bg-secondary text-primary'>
			<motion.div
				initial={{ y: 50, opacity: 0 }}
				whileInView={{ y: 0, opacity: 1 }}
				viewport={{ once: true }}
				transition={{ duration: 0.5 }}>
				<h3 className='text-3xl font-bold text-center mb-8'>Nasze Usługi</h3>
				<div className='flex flex-wrap justify-center gap-6'>
					<div className='w-72 p-6 bg-white shadow-xl rounded-lg transition transform hover:scale-105 hover:shadow-2xl'>
						<h4 className='text-xl font-bold mb-2'>Księgowość</h4>
						<p>Prowadzenie księgowości oraz ewidencji VAT.</p>
					</div>
					<div className='w-72 p-6 bg-white shadow-xl rounded-lg transition transform hover:scale-105 hover:shadow-2xl'>
						<h4 className='text-xl font-bold mb-2'>Działalność gospodarcza</h4>
						<p>
							Księgowość uproszczona dla jednoosobowych działalności
							gospodarczych.
						</p>
					</div>
					<div className='w-72 p-6 bg-white shadow-xl rounded-lg transition transform hover:scale-105 hover:shadow-2xl'>
						<h4 className='text-xl font-bold mb-2'>Obsługa kadrowa</h4>
						<p>Pełna obsługa kadr i płac dla firm.</p>
					</div>
				</div>
			</motion.div>
		</section>
	)
}
